import { createFileRoute } from '@tanstack/react-router';
import ReportSummary from '@piwikpro/single-digital-gateway-crate/components/ReportSummary';

export const Route = createFileRoute('/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit')({
  component: ReportSummary,
});
